import Layer from "@mozaic-ds/freemarker/js/modules/_layer";
const SAMPLE_CLASS = '.js-samplecdp';
const SAMPLE_BUTTON_CLASS = '.js-open-sample';
const SAMPLE_LAYER_CLASS = 'js-layer-sample';
class SampleProduct extends lm.Composant {
  constructor(id) {
    super(id);
    this.initSampleLayer();
  }
  initSampleLayer() {
    const sample = document.querySelector(SAMPLE_CLASS);
    if (sample) {
      const sampleButton = document.querySelector(SAMPLE_BUTTON_CLASS);
      if (sampleButton) {
        const layerSample = new Layer({
          'classContent': SAMPLE_LAYER_CLASS
        });
        sampleButton.addEventListener('click', () => {
          layerSample.open();
        });
      }
    }
  }
}
lm.DOMReady(function () {
  new SampleProduct("sampleProduct");
});
export default SampleProduct;